"use client";

/**
 * Step 2 — Enrichment. The four waterfall strategies as radio cards, sourced
 * from `WATERFALL_META`/`WATERFALL_ORDER`. Back + Continue.
 */

import { Button, SubmitButton } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { StepFooter, StepScrollArea } from "@/components/wizard";
import { cn } from "@/lib/utils";

import { ENROLLMENT_ACCENT_TEXT, ENROLLMENT_PRIMARY_BTN } from "../../lib/theme";
import { WATERFALL_META, WATERFALL_ORDER } from "../../lib/waterfall-meta";
import { useConfigureWizard } from "./context";

export function StepEnrichment() {
  const { waterfall, selectWaterfall, setStep } = useConfigureWizard();

  return (
    <>
      <StepScrollArea contentClassName="flex flex-col gap-4">
        <p className="text-sm text-muted-foreground">
          How we find each candidate&apos;s contact info when none is on file.
        </p>

        <fieldset
          className="flex flex-col gap-2"
          aria-label="Waterfall enrichment strategy"
        >
          {WATERFALL_ORDER.map((value) => {
            const meta = WATERFALL_META[value];
            const selected = waterfall === value;
            return (
              <label
                key={value}
                className={cn(
                  "flex w-full cursor-pointer items-start gap-3 rounded-lg border p-3 transition-colors",
                  selected
                    ? "border-[#5FBF77] bg-[#87FFA5]/5"
                    : "border-border bg-contrast/[0.02] hover:border-foreground/15 hover:bg-contrast/4",
                )}
              >
                <input
                  type="radio"
                  name="enroll-configure-waterfall"
                  value={value}
                  checked={selected}
                  onChange={() => selectWaterfall(value)}
                  className="sr-only"
                />
                <div className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-[#87FFA5]/10">
                  <Icon
                    name={meta.icon}
                    size={16}
                    className={ENROLLMENT_ACCENT_TEXT}
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col items-start text-left">
                  <span className="text-sm font-medium text-foreground">
                    {meta.label}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {meta.description}
                  </span>
                </div>
                <div
                  className={cn(
                    "mt-0.5 flex size-4 shrink-0 items-center justify-center rounded-full border transition-colors",
                    selected ? "border-[#5FBF77] bg-[#87FFA5]" : "border-contrast/25",
                  )}
                >
                  {selected && <div className="size-1.5 rounded-full bg-black" />}
                </div>
              </label>
            );
          })}
        </fieldset>
      </StepScrollArea>
      <StepFooter>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => setStep(1)}
        >
          Back
        </Button>
        <SubmitButton
          type="button"
          size="sm"
          onClick={() => setStep(3)}
          className={ENROLLMENT_PRIMARY_BTN}
        >
          Continue
        </SubmitButton>
      </StepFooter>
    </>
  );
}
